export default __webpack_public_path__ + "static/icon-light-921394f0811ffbecb3580ad018cd467552b5422000f36cd21cfe6d7a2c3580c5.png";